import {
  Fragment,
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { useParams } from 'react-router-dom'

import LoadingPage from '@/components/LoadingPage'
import { RenderIf } from '@/components/RenderIf'
import TimeZoneLuxon from '@/components/TimeZoneLuxon'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { getThemeByUniqueCode } from '@/theme'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import { setCache } from '@/utils/cache'
import { Text } from '@conexasaude/conexa-hero'
import { ForgotPasswordForm } from '../../components/ForgotPasswordForm'
import { LightHeader } from '../../components/LightHeader'
import { useStyles } from './styles'
import { ForgotPasswordParams } from './types'

const ForgotPassword: FunctionComponent = () => {
  const [isLoading, setIsLoading] = useState(true)

  const { clinic } = useParams<ForgotPasswordParams>()
  const { theme, setThemeColors } = useThemeGeneratorContext()
  const styles = useStyles()
  const { user } = useAuthContext()

  const getAndSetThemeColors = useCallback(async () => {
    try {
      const colors = await getThemeByUniqueCode(clinic, theme)

      setThemeColors(colors)
    } catch {
      setThemeColors(null)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinic])

  useEffect(() => {
    setIsLoading(true)

    if (clinic) {
      getAndSetThemeColors()
      setCache('unique-code', clinic)
      setIsLoading(false)

      return
    }

    setThemeColors(null)
    setCache('unique-code', '')
    setIsLoading(false)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) return <LoadingPage withoutNav />

  return (
    <Fragment>
      <LightHeader
        uniqueCode={clinic}
        redirectTo={clinic ? `/login/${clinic}` : '/login'}
      />
      <div css={styles.container}>
        <ForgotPasswordForm />
        <div css={styles.tzContainer}>
          <TimeZoneLuxon />
          <RenderIf condition={Boolean(user?.patientId)}>
            <Text>
              ID: {user?.patientId} | Clínica: {user?.clinic?.name}
            </Text>
          </RenderIf>
        </div>
      </div>
    </Fragment>
  )
}

export default ForgotPassword
